import React,{useEffect,useState} from 'react';
import Container from 'react-bootstrap/Container'
import {gsap,TimelineMax,Power4 } from "gsap";

const FrontSliderBlurb =(props) => {
    let [disp,setDisp] = useState("block");
    useEffect(() => {
        if(props.show === "true"){
            setTimeout(function(){ showBlurb(); }, props.delay);
        }
        let sbbg = document.getElementById("sliderblurb");
        sbbg.classList.add("sliderblurb-motion");
        //eslint-disable-next-line
    },[]);

    function showBlurb(){
        let blurbElement = document.getElementById('blurbWrapper');
        gsap.set(blurbElement, {display:"block"});

        let element = document.getElementsByClassName('tdp-login-element');
        for (let i = 0; i < element.length; ++i) {
            gsap.set(element, {x:310,opacity:0});
        }
        let myTimeline = new TimelineMax();
        myTimeline.staggerTo(element, 1, {x:0,opacity:1,ease:Power4.easeOut,delay:.1}, .1);

        gsap.to(document.getElementById('sliderblurb'), 30, {backgroundPosition:"-1310 0"});
    }

    let top = (props.top) ? props.top : 100;
    let left = (props.left) ? props.left-790 : -690;

    return (
      <Container id="blurbWrapper" fluid style={{display:disp,position:"absolute",top:top,left:left,zIndex:40000}} >

            <div className="sliderblurb tdp-login-element" id="sliderblurb" style={{width:500,fontFamily:"Bubblegum Sans",position:"relative"}}>
                <div className="tdp-login-element" style={{textAlign:"center",fontSize:"20pt",color:"slateblue"}}>Info</div>
                <div style={{fontSize:"15pt",textAlign:"left",color:"#585858"}} className="sliderblurb-content tdp-login-element">
                    {props.blurb}
                </div>
                <div className="x-out" onClick={()=>setDisp("none")} />
            </div>

      </Container>
    )
};

export default FrontSliderBlurb;
